export default __webpack_public_path__ + "static/media/approval-icon.287a1a1c.svg";